module.exports = __webpack_public_path__ + "static/img/p6.925164f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p6.jpg
// module id = 67
// module chunks = 1